module.exports = __webpack_public_path__ + "static/media/gray_10.f7004add.jpg";